<template>
  <OtivoButton v-if="isItSuncorpstaff" colour="white" @click="openStaffBenefitsInNewTab()">
    Staff benefits
  </OtivoButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSessionStore } from '@/store/pinia/SessionStore'
import OtivoButton from '@/components/OtivoButton.vue'

// Emits
const emit = defineEmits<{
  click: []
}>()

// Composables
const sessionStore = useSessionStore()

// Computed properties (replacing Vuex mapGetters)
const isItSuncorpstaff = computed(() => sessionStore.getWhitelabelData.identifier === 'SUNCORP')

// Methods
const openStaffBenefitsInNewTab = (): void => {
  window.open(
    'https://suncorprecognition.rewardgateway.com/Authentication/Login?r=login&page=login&it=%2FSmartPage%2Fgroup_benefits',
    '_blank'
  )
  emit('click')
}
</script>

<style scoped></style>
